/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the AudienceFilter interface.
 */
export function instanceOfAudienceFilter(_value) {
    return true;
}
export function AudienceFilterFromJSON(json) {
    return AudienceFilterFromJSONTyped(json, false);
}
export function AudienceFilterFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'planTier': json['plan_tier'] == null ? undefined : json['plan_tier'],
        'registeredAfter': json['registered_after'] == null ? undefined : (new Date(json['registered_after'])),
        'registeredBefore': json['registered_before'] == null ? undefined : (new Date(json['registered_before'])),
    };
}
export function AudienceFilterToJSON(json) {
    return AudienceFilterToJSONTyped(json, false);
}
export function AudienceFilterToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'plan_tier': value['planTier'],
        'registered_after': value['registeredAfter'] == null ? value['registeredAfter'] : value['registeredAfter'].toISOString(),
        'registered_before': value['registeredBefore'] == null ? value['registeredBefore'] : value['registeredBefore'].toISOString(),
    };
}
